<template>
	<div class="result">
		<div class="card-container">
			<div class="title">考生信息</div>
			<ul>
				<li>
					<span>姓名：</span>
					<span>{{data.student_name}}</span>
				</li>
				<!-- <li>
					<span>姓名全拼：</span>
					<span>{{}}</span>
				</li> -->
				<li>
					<span>性别：</span>
					<span v-if="data.student_gender === 0">男</span>
					<span v-if="data.student_gender === 1">女</span>
				</li>
				<!-- <li>
					<span>出生日期：</span>
					<span>{{}}</span>
				</li> -->
				<li>
					<span>民族：</span>
					<span>{{data.student_nation}}</span>
				</li>
				<li>
					<span>国籍：</span>
					<span>{{data.student_country}}</span>
				</li>
				<li>
					<span>身份证号：</span>
					<span>{{data.student_id_card}}</span>
				</li>
			</ul>

			<div class="title">考场信息</div>
			<ul>
				<li>
					<span>承办机构：</span>
					<span>{{data.agent_title}}</span>
				</li>
				<li>
					<span>准考证号：</span>
					<span>{{data.exam_number}}</span>
				</li>
				<li>
					<span>考试时间：</span>
					<span>{{data.exam_start_time}}</span>
				</li>
				<li>
					<span>考试科目：</span>
					<span>{{data.subject_title}}</span>
				</li>
				<li>
					<span>报考等级：</span>
					<span>{{data.rank_req}}</span>
				</li>
				<li>
					<span>所属考场：</span>
					<span>{{data.exam_title}}</span>
				</li>
				<!-- <li>
					<span>座位号：</span>
					<span>{{data.seat_number}}</span>
				</li> -->
				<li>
					<span>考场地址：</span>
					<span>{{data.region_address}}</span>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
		};
	},
	props: {
		data: {
			type: [Object],
			default() {
				return {};
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.result {
	border: 1px solid #eaeaea;
	margin-top: 10px;
	.card-container {
		.title {
			font-size: 24px;
			color: #363636;
			margin-top: 45px;
			text-align: center;
			&:after {
				content: "";
				display: block;
				width: 59px;
				height: 2px;
				background: #c9c9c9;
				margin: 0 auto;
				margin-top: 10px;
			}
		}
		ul {
			width: 80%;
			margin: 0 auto;
			padding: 20px 10px;
			li {
				margin-bottom: 15px;
				display: table;
				border-bottom: 1px solid #e7e7e7;
				padding-bottom: 15px;
				width: 100%;
				span {
					display: table-cell;
					vertical-align: baseline;

					&:first-child {
						width: 65px;
						text-align: right;
					}
					&:last-child {
						margin-left: 20px;
						text-align: left;
						word-break: break-all;
					}
				}
			}
		}
	}
}
</style>
